import React from 'react'
import FormRowHeaderCell from './FormRowHeaderCell'
import FormRowCell from './FormRowCell'
const FormRow = ({ isHeader, callbacks, rowData, selectRow, widths, states, isSelected, centeredIndices = [], collapsibleIndices = [], filterCBs=[] ,openModal}) => {
    // isHeader === true
    // rowData = ["Name", "ID", "Status", "Auth"]

    //or 

    //isHeader === false
    //rowData = ["Dev Device, '23dsdfs09f920", "Online", 1]

    const content = rowData.map((text, index) => {
        return isHeader ? <FormRowHeaderCell 
                title={text} 
                sorting={states[index]} 
                collapsibleHeader={collapsibleIndices[index]}
                sort={callbacks[index]}
                filter={filterCBs[index]}
                width={widths[index]}
                key={index}
            /> 
        : 
            <FormRowCell key={index} text={text} width={widths[index]} cb={selectRow} centerText={centeredIndices.includes(index)}/>
    })
            return <div style={{width: "100%"}} className={`${isSelected ? "selected" : ""}`}> 
                    <ul id="row-container" className="flex-centered max-width " onClick={openModal? openModal : null} >
                        {content}
                    </ul>
                </div>
}

export default FormRow